import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDiscordBotQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type GetDiscordBotQuery = {
  __typename?: 'Query';
  discordBot?: {
    __typename?: 'DiscordBot';
    id: any;
    botUsername?: string | null;
    guildName?: string | null;
    channels: Array<{
      __typename?: 'DiscordBotChannel';
      id: any;
      name?: string | null;
      channelType: Types.DiscordChannelTypeEnum;
      isArchived: boolean;
    }>;
  } | null;
};

export const GetDiscordBotDocument = gql`
  query GetDiscordBot($id: UUID!) {
    discordBot(id: $id) {
      id
      botUsername
      guildName
      channels {
        id
        name
        channelType
        isArchived
      }
    }
  }
`;

/**
 * __useGetDiscordBotQuery__
 *
 * To run a query within a React component, call `useGetDiscordBotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscordBotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscordBotQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDiscordBotQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDiscordBotQuery,
    GetDiscordBotQueryVariables
  > &
    (
      | { variables: GetDiscordBotQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDiscordBotQuery, GetDiscordBotQueryVariables>(
    GetDiscordBotDocument,
    options,
  );
}
export function useGetDiscordBotLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDiscordBotQuery,
    GetDiscordBotQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDiscordBotQuery, GetDiscordBotQueryVariables>(
    GetDiscordBotDocument,
    options,
  );
}
export function useGetDiscordBotSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDiscordBotQuery,
        GetDiscordBotQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDiscordBotQuery,
    GetDiscordBotQueryVariables
  >(GetDiscordBotDocument, options);
}
export type GetDiscordBotQueryHookResult = ReturnType<
  typeof useGetDiscordBotQuery
>;
export type GetDiscordBotLazyQueryHookResult = ReturnType<
  typeof useGetDiscordBotLazyQuery
>;
export type GetDiscordBotSuspenseQueryHookResult = ReturnType<
  typeof useGetDiscordBotSuspenseQuery
>;
export type GetDiscordBotQueryResult = Apollo.QueryResult<
  GetDiscordBotQuery,
  GetDiscordBotQueryVariables
>;
